import React, { Component } from "react";

import AdminVideoCategories from "../VideoCategories/VideoCategories";

class AdminWorkflowVideoCategories extends Component {
  render() {
    return <AdminVideoCategories workflow {...this.props} />;
  }
}

export default AdminWorkflowVideoCategories;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/WorkflowVideoCategories/WorkflowVideoCategories.js